export const getMedia = (state) => state.media
export const getPages = (state)=> state.pages
